module.exports = __webpack_public_path__ + "static/Trans-7-Clean-8b2b9eca5115e5d5f1d109d977178688.svg";